window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

// Plugins imports
require('@fancyapps/fancybox');
require('ion-rangeslider');
require('slick-carousel');
require('lazysizes');

/**
 * @todo [CONSENT_TRACKING] verify if is required to import consentTracking.js file
 */
$(document).ready(function () {
    processInclude(require('base/components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/footer'));
    processInclude(require('base/components/miniCart'));
    processInclude(require('site/components/collapsibleItem'));
    processInclude(require('base/components/search'));
    processInclude(require('base/components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('site/priceSlider/priceSlider'));
    processInclude(require('./components/goBack'));
    processInclude(require('./components/rateApp'));
    processInclude(require('./components/externalURL'));
    processInclude(require('./components/sharing'));
    processInclude(require('./components/product/product'));
    processInclude(require('./components/spinner'));
    processInclude(require('./components/alert'));
    processInclude(require('./components/login'));
    processInclude(require('./components/panel'));
    processInclude(require('./components/minicart'));
    processInclude(require('./components/carousel'));
    processInclude(require('./components/checkoutHeader'));
});

require('base/thirdParty/bootstrap');
require('base/components/spinner');
